































import { Component, Vue, Provide } from "vue-property-decorator";
import { ColumnsConfig } from "@/common/BaseConfig";
import request from "@/api/index";
import { INewsItem, IColumn } from "@/api/types.d";
import NewsItem from "@/components/NewsItem.vue";
import { List, PullRefresh } from "vant";
@Component({
  components: {
    NewsItem,
    VanList: List,
    VanPullRefresh: PullRefresh
  }
})
export default class PolicyRelease extends Vue {
  currentIndex: number = 99;
  columnList: IColumn[] = [];

  columnId: string = "";
  newsList: INewsItem[] = [];
  private loading: boolean = false;
  private finished: boolean = false;
  private lastItem?: INewsItem;
  private isLoading: boolean = false;
  mounted() {
    this.getColumns();
  }
  getColumns() {
    request.getColumns(ColumnsConfig.政策发布).then(result => {
      if (result.code === 0 && result.data.dataList) {
        this.columnList = result.data.dataList;
        this.tagClick(0, this.columnList[0].id + "");
      }
    });
  }

  /** 获取新闻列表 */
  getNewsList(isClear: boolean = false) {
    const lastId = this.lastItem ? this.lastItem!.id : undefined;
    const lastSortNo = this.lastItem ? this.lastItem!.sortNo : undefined;
    const lastOnlineTime = this.lastItem
      ? this.lastItem!.onlineTime
      : undefined;
    request
      .getNews(false, this.columnId + "", lastId, lastSortNo, lastOnlineTime)
      .then(result => {
        if (isClear) {
          this.newsList = [];
          this.finished = false;
        }
        if (!result.data.news || result.data.news.length === 0) {
          this.finished = true;
        } else {
          this.newsList = this.newsList.concat(result.data.news);
          this.lastItem = result.data.news.lastChild;
        }
        this.isLoading = false;
        this.loading = false;
      });
  }

  tagClick(index: number, id: string) {
    if (this.currentIndex === index) {
      return;
    }
    this.currentIndex = index;
    this.columnId = id;
    this.lastItem = undefined;
    this.getNewsList(true);
  }
  onLoad() {
    this.getNewsList();
  }
  onRefresh() {
    this.lastItem = undefined;
    this.getNewsList(true);
  }
}
